var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "footer z-index-0 mt-md-0 mt-5" }, [
    _c("div", { staticClass: "container position-relative" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column flex-md-row-reverse wrapper justify-content-between"
        },
        [
          _c(
            "nav",
            { staticClass: "d-flex flex-row wrapper justify-content-between" },
            [
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: { to: { name: "privacy-policy" } }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("privacyPolicyPage.title")) +
                      "\n        "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                {
                  staticClass: "link",
                  attrs: { to: { name: "cookie-policy" } }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("cookiePolicyPage.title")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "copyright" }, [
            _vm._v(
              "© " +
                _vm._s(_vm.thisYear) +
                " " +
                _vm._s(_vm.$t("footer.copyright"))
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary floating-btn",
          attrs: { type: "button" },
          on: { click: _vm.openFreshChat }
        },
        [
          _c("span", { staticClass: "d-inline-flex align-items-center" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("footer.consultationCTA")) +
                "\n      "
            )
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              "aria-hidden": "true",
              src: "/images/svg/chat-rectangle.svg",
              height: "24",
              alt: ""
            }
          })
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }